export const UNICODE_CHARS = {
  BULLET: '\u2022',
};
